<template>
  <div id="navigation-drawer-view" class="white">
    <v-container fluid>
      <v-layout row justify-center>
        <v-flex xs10>
          <v-card class="mt-3" color="blue darken-1 white--text">
            <v-card-text>
              <v-layout row justify-center>
                <div class="display-1 my-3">Otorga acceso a tus vehículos</div>
              </v-layout>
              <v-layout row justify-center>
                <div class="body-1">
                  Invitados te permite compartir tus vehículos a través de una nueva cuenta
                  que podrás crear a continuación.
                </div>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12>
          <div class="guests mt-3">
            <v-list two-line subheader>
              <v-subheader>Invitados</v-subheader>
              <v-layout row wrap>
                <v-flex xs12 sm6 md4 xl3 v-for="(guest, index) in guests" :key="index">
                  <v-list-tile
                    avatar
                    class="guest-tile"
                    @click="openUpdateGuestDialog({ guest })"
                  >
                    <v-list-tile-avatar>
                      <v-icon class="primary white--text">person</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>{{ guest.name }}</v-list-tile-title>
                      <v-list-tile-sub-title>{{ guest.username }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                    <v-list-tile-action>
                      <v-btn icon @click.stop="openConfirmRemoveGuestDialog({ _id: guest._id })">
                        <v-icon color="primary">delete</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                  </v-list-tile>
                </v-flex>
                <v-flex xs12 sm6 md4 xl3>
                  <v-list-tile
                    avatar
                    class="create-guest-tile"
                    @click="openCreateGuestDialog"
                  >
                    <v-list-tile-avatar>
                      <v-icon class="green lighten-1 white--text">add</v-icon>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>Agregar Invitado</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-flex>
              </v-layout>
            </v-list>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <create-guest-dialog
      :vehicles="vehicles"
      :permissions="permissions"
      @create-guest="createGuest"
      ref="createGuestDialog"
    />
    <update-guest-dialog
      :vehicles="vehicles"
      :permissions="permissions"
      @update-guest="updateGuest"
      ref="updateGuestDialog"
    />
    <v-dialog
      v-if="guestToRemove"
      v-model="confirmRemoveGuestDialog"
      :max-width="290"
      class="confirm-remove-guest-dialog"
    >
      <v-card>
        <v-card-title primary-title>
          <div class="headline">¿Realmente desea eliminar el invitado {{ guestToRemove.username }}?</div>
        </v-card-title>
        <v-card-text>
          Si elimina la cuenta, el invitado no tendrá acceso a sus vehículos.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="confirmRemoveGuestDialog = false">cancelar</v-btn>
          <v-btn
            flat
            color="primary"
            @click="removeGuest"
            :loading="removingGuest"
          >eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { find } from 'lodash'
import CreateGuestDialog from '@/components/CreateGuestDialog'
import UpdateGuestDialog from '@/components/UpdateGuestDialog'

export default {
  name: 'guests',
  data: function () {
    return {
      guestToRemove: null,
      confirmRemoveGuestDialog: false,
      removingGuest: false
    }
  },
  computed: {
    guests: function () {
      return this.$store.getters['Guests/guests']
    },
    vehicles: function () {
      return this.$store.state.Guests.vehicles
    },
    permissions: function () {
      return this.$store.state.Guests.permissions
    }
  },
  created: function () {
    this.$store.dispatch('Guests/fetchVehicles')
    this.$store.dispatch('Guests/fetchGuests')
    this.$store.dispatch('Guests/fetchPermissions')
  },
  components: {
    'create-guest-dialog': CreateGuestDialog,
    'update-guest-dialog': UpdateGuestDialog
  },
  methods: {
    openUpdateGuestDialog: function ({ guest }) {
      this.$refs.updateGuestDialog.open({ guest })
    },
    openCreateGuestDialog: function () {
      this.$refs.createGuestDialog.open()
    },
    createGuest: async function ({ guest }) {
      try {
        await this.$store.dispatch('Guests/createGuest', { guest })
      } catch (e) {
        const message = e.graphQLErrors[0] ? e.graphQLErrors[0].message : 'Ooops, ha ocurrido un error'
        this.$refs.createGuestDialog.displayError(message)
        return console.error(e)
      }
      this.$refs.createGuestDialog.close()
    },
    updateGuest: async function ({ _id, guest }) {
      try {
        await this.$store.dispatch('Guests/updateGuest', { _id, guest })
      } catch (e) {
        const message = e.graphQLErrors[0] ? e.graphQLErrors[0].message : 'Ooops, ha ocurrido un error'
        this.$refs.updateGuestDialog.displayError(message)
        return console.error(e)
      }
      this.$refs.updateGuestDialog.close()
    },
    openConfirmRemoveGuestDialog: function ({ _id }) {
      const guest = find(this.guests, { _id })
      if (!guest) return false
      this.guestToRemove = guest
      this.confirmRemoveGuestDialog = true
    },
    removeGuest: async function () {
      if (!this.guestToRemove || !this.guestToRemove._id) return false
      this.removingGuest = true
      await this.$store.dispatch('Guests/removeGuest', { _id: this.guestToRemove._id })
      this.removingGuest = false
      this.confirmRemoveGuestDialog = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Guests.vue